import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import './SupportGuide.css';

export const SUPPORT_EMAIL = 'angel@plactical.com';

export const openChannelTalk = (showToast) => {
  if (window.ChannelIO) {
    window.ChannelIO('show');
  } else {
    showToast('채팅 상담을 준비하고 있어요. 잠시 후 다시 눌러주세요', 'info');
  }
};

export const SupportGuideLayout = ({ current, currentTo, children }) => (
  <div className="sg-page">
    <main className="sg">
      <nav className="sg__crumb" aria-label="위치">
        <Link to="/help">고객센터</Link>
        <span aria-hidden="true">›</span>
        {current ? (
          <>
            <Link to="/support">사용 가이드</Link>
            <span aria-hidden="true">›</span>
            {currentTo ? <Link to={currentTo}>{current}</Link> : <span>{current}</span>}
          </>
        ) : (
          <span>사용 가이드</span>
        )}
      </nav>
      {children}
    </main>
  </div>
);

export const SupportFaqList = ({ faqs, openFirst = true }) => (
  <div className="sg__faq">
    {faqs.map((faq, index) => (
      <details key={faq.id} open={openFirst && index === 0}>
        <summary>{faq.question}</summary>
        <div
          className="sg__faq-body"
          dangerouslySetInnerHTML={{ __html: faq.answer }}
        />
      </details>
    ))}
  </div>
);

export const SupportLinkList = ({ items }) => (
  <ul className="sg__links">
    {items.map((item) => (
      <li key={item.to || item.href}>
        {item.href ? (
          <a href={item.href} target="_blank" rel="noopener noreferrer">
            <b>{item.title}</b>
            {item.body && <span>{item.body}</span>}
          </a>
        ) : (
          <Link to={item.to}>
            <b>{item.title}</b>
            {item.body && <span>{item.body}</span>}
          </Link>
        )}
      </li>
    ))}
  </ul>
);

export const SupportSearch = ({ search, placeholder }) => {
  const [query, setQuery] = useState('');
  const results = useMemo(() => (query.trim() ? search(query.trim()) : []), [query, search]);
  const hasQuery = Boolean(query.trim());

  return (
    <div className="sg__search">
      <input
        type="search"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        placeholder={placeholder}
        aria-label="도움말 검색"
      />
      {hasQuery && (
        results.length > 0 ? (
          <ul className="sg__results" aria-label="검색 결과">
            {results.map((faq) => (
              <li key={faq.id}>
                <Link to={`/support/faq/${faq.id}`}>{faq.question}</Link>
              </li>
            ))}
          </ul>
        ) : (
          <p className="sg__empty">찾는 내용이 없어요. 아래 채팅 상담으로 물어봐 주세요.</p>
        )
      )}
    </div>
  );
};

export const SupportHelpFooter = ({ onChat, text = '원하는 답이 없으면' }) => (
  <p className="sg__help">
    {text}
    <button type="button" onClick={onChat}>채팅 상담으로 물어보기</button>
    <span aria-hidden="true">·</span>
    <a href={`mailto:${SUPPORT_EMAIL}`}>이메일 문의</a>
  </p>
);
